<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Book Description</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">Twin hybrid vampires Daniel and Diana feel technology’s cold, uncountable tendrils hunting them. Daniel scientifically satisfies his needs. Diana hunts old-school, leaving patches of greasy, scorched earth or mutilated bodies for her brother to take care of.</p>
<p class="subsq">Daniel created Matrix, a face pack for beauty shops, which pulls blood through skin, leaves blissful clients, kills and alerts no one. He prefers milking to butchering. Daniel cultivates his human side; Diana mocks him. Impatient, she hunts out of spite as much as need.</p>
<p class="subsq">Daniel finally understands that his twin sister will get him killed, and his life’s hardest decision is at hand: Blood? Or Death?</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// book-description.vue?7f753be2